export interface FileUploadComponentProps {
    title?: string;
    style?: React.CSSProperties;
    isRequired?: boolean;
    value?: string | number | undefined;
    onChange?: (fileData: FileData[] | null) => void;
    placeholder?: string;
    error?: boolean;
    isDisabled?: boolean;
    size?: "small" | "middle" | "large";
    readonly?: boolean;
    dimensions?: string;
    fileSize: string;
    fileSizeText: string;
    format: string;
    defaultValue?: string | null;
    multiple?: boolean;
}

export interface FileData {
    name: string;
    size: number;
    type: string;
    url: string | ArrayBuffer | null;
    file: File | null;
}

export const formatToMimeType: Record<string, string[]> = {
	"jpeg": ["image/jpeg"],
	"jpg": ["image/jpeg"],
	"png": ["image/png"],
	"gif": ["image/gif"],
	"bmp": ["image/bmp"],
	"webp": ["image/webp"],
	"pdf": ["application/pdf"],
	"ppt": ["application/vnd.ms-powerpoint"],
	"pptx": ["application/vnd.openxmlformats-officedocument.presentationml.presentation"],
	"doc": ["application/msword"],
	"docx": ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
	"xls": ["application/vnd.ms-excel"],
	"xlsx": ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
};